import { combineReducers } from "redux";
import broadcast from "../features/admin/broadcast/broadcast/Slice";

const masters = combineReducers({
  broadcast: broadcast,
});

export default masters;
